import { Avatar, Box, Card, CardContent, Grid2, IconButton, Stack, Typography, useTheme } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useState } from "react";
import { MdOutlineArrowOutward } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";

// const data = [
//     {
//         label: 'Planned Value',
//         value: 2051.62
//     },
//     {
//         label: 'Actual Cost',
//         value: 2040.13
//     },
//     {
//         label: 'Earned Value',
//         value: 2040.13
//     }
// ];
// const categories = [
//     "Jul,24",
//     "Aug,24",
//     "Sep,24",
//     "Oct,24",
//     "Nov,24",
//     "Dec,24",
//     "Jan,25",
//     "Feb,25",
//     "Mar,25",
//     "Apr,25",
//     "May,25",
//     "Jun,25",
//     "Jul,25",
//     "Aug,25",
//     "Sep,25",
//     "Oct,25"
// ];
// const actualData = [10.78, 39.5, 96.98, 213.34, 383.01, 626.8, 943.68, 1285.06, 1602.09, 1846.02, 2040.29];
// const planData = [12.23, 41.57, 100.26, 217.64, 388.81, 633.34, 951.23, 1293.57, 1611.46, 1855.99, 2051.62];
// const earnedData = [10.76, 39.61, 97.08, 213.23, 382.94, 626.74, 943.65, 1285.02, 1602.17, 1845.97, 2040.38];


const EarnedValueManagementProjectLanding = (props) => {
    const { earnValueData } = props;
    const { projectId } = useParams();
    const navigate = useNavigate();
    const theme = useTheme();
    const [category, setCategory] = useState([]);
    const [planData, setPlanData] = useState([]);
    const [actualData, setActualData] = useState([]);
    const [earnedData, setEarnedData] = useState([]);

    // const categories = ["Jan,24", "Feb,24", "Mar,24", "Apr,24", "May,24"]

    // const actualData = [10, 20, 30, 50, 70];
    // const plannedData = [0, 30, 20, 50, 30];
    // const earnedData = [20, 40, 15, 20, 25];

    useEffect(() => {
        if (earnValueData?.isSuccess) {
            setCategory(earnValueData?.data?.data?.map((item) => item?.month));
            setPlanData(earnValueData?.data?.data?.map((item) => item?.planned > 0 ? item?.planned : null));
            setActualData(earnValueData?.data?.data?.map((item) => item?.actual > 0 ? item?.actual : null));
            setEarnedData(earnValueData?.data?.data?.map((item) => item?.ev > 0 ? item?.ev : null))
        }
    }, [earnValueData])

    const options = {
        chart: { type: "spline", height: 400 },
        colors: ["#E72B33", "#295477", "#3E756D"],
        title: { text: "" },
        xAxis: {
            categories: category,
            labels: {
                style: {
                    fontSize: '10px',
                    fontWeight: 500,
                    color: '#414D55'
                }
            }
        },
        yAxis: {
            title: { text: "" },
            gridLineWidth: 1,
            // tickPositioner: function () {
            //     let positions = [0];
            //     for (let i = 100; i <= 2100; i += 100) {
            //         positions.push(i);
            //     }
            //     return positions;
            // },
        },
        legend: {
            align: "left",
            verticalAlign: "top",
            layout: "horizontal",
            itemDistance: 8,
            useHTML: true,
            symbolWidth: 0,
            x: -20,
            itemMarginBottom: 40,
            labelFormatter: function () {
                return `<span style="display: inline-block; width: 13px; height: 13px; background-color: ${this.color};"></span> <span style="font-size:15px; font-weight:500, color:#00000080">${this.name}</span>`;
            },
        },
        plotOptions: {
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: () => {
                            localStorage.setItem("costTabIndex", 0);
                            navigate(`/projects/${projectId}?type=cost`);
                        }
                    }
                },
            },
        },
        tooltip: {
            shared: true,
            useHTML: true,
            backgroundColor: "#00000080",
            showdow: false,
            formatter: function () {
                let tooltipHtml = ``;
                this.points.forEach((point) => {
                    tooltipHtml += `<b>${point.series.name}: ${point.y ?? 0}</b><br/>`;
                });

                return tooltipHtml;
            },
            style: {
                color: '#fff'
            }
        },
        credits: {
            enabled: false,
        },
        series: [
            {
                name: "Actual Cost",
                data: actualData,
                marker: { enabled: false, symbol: "circle" },
                lineWidth: 3,
            },
            {
                name: "Planned Value",
                data: planData,
                marker: { enabled: false, symbol: "circle" },
                lineWidth: 3,
            },
            {
                name: "Earned Value",
                data: earnedData,
                marker: { enabled: false, symbol: "circle" },
                lineWidth: 3,
            },
        ],
    };

    return (
        <Box sx={{ padding: 2, pb: 0, border: '1px solid #2525252E', borderRadius: '7px', background: "#FFFFFF" }}>
            <Grid2 size={{ xs: 12, md: 12 }} sx={{ mb: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '18px', color: `#182A4E`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                    Earned Value Management
                </Typography>
                <Typography variant="caption" sx={{ fontWeight: "500", fontSize: '14px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                    Linking progress with budget and schedule metrics
                </Typography>
            </Grid2>
            <Grid2 size={{ md: 12 }}>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </Grid2>
        </Box>
    );
};

export default EarnedValueManagementProjectLanding;
